import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Slider from 'react-slick'
import home_bg from '../../../assets/home_bgs.png'
import home_bg2 from '../../../assets/home_bgs2.png'

const HomeCarousel = () => {
	const navigate = useNavigate()

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const settings = {
		dots: true,
		infinite: true,
		speed: 1500,
		slidesToShow: 1,
		arrows: false,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 9000,
		pauseOnHover: false,
	}

	const clickHandler = (e) => {
		e.preventDefault()
		if (userDetail) {
			navigate('/user/dashboard/submissions/create')
		} else {
			navigate('/login')
			if (userDetail) {
				setTimeout(() => {
					navigate('/user/dashboard/submissions/create')
				}, 1000)
			}
		}
	}

	return (
		<>
			<Slider {...settings}>
				<div>
					<div
						style={{ backgroundImage: `url(${home_bg})` }}
						className='homepage_bg'
					>
						<div className='container'>
							<div className='d-flex homepage_flexdiv'>
								<div className=''>
									<h1>DO YOU HAVE A SCRIPT?</h1>
									<p>
										Submit your script to <strong>Alofund</strong>, a movie fund
										for micro-budget social impact African films aimed at
										dealing with societal issues.
									</p>
									<Link
										to='#'
										onClick={clickHandler}
										className='btn homepage_btn'
									>
										Submit Script
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div>
					<div
						style={{ backgroundImage: `url(${home_bg2})` }}
						className='homepage_bg'
					>
						<div className='container'>
							<div className='d-flex homepage_flexdiv'>
								<div className=''>
									<h1>ARE YOU A PROFESSIONAL?</h1>
									<p>
										Join the platform to showcase your portfolio and get gig
										oppourtunities.
									</p>
									<Link
										to='#'
										onClick={clickHandler}
										className='btn homepage_btn'
									>
										Join Here
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Slider>
		</>
	)
}

export default HomeCarousel
